import apiClient from '../plugins/axios';

/**
 * GET /call-message/{id}/audio — ham ses (Bearer ile blob; HTML audio src tek başına token gönderemez).
 */
class CallMessageService {
  async fetchAudioBlob(messageId) {
    const response = await apiClient.get(`call-message/${messageId}/audio`, {
      responseType: 'blob',
      skipLoading: true,
      skipErrorNotification: true,
    });
    return response.data;
  }
}

export default new CallMessageService();
